module.exports = __webpack_public_path__ + "img/btn02.c5d35e02.png";